// @flow

import updateEstimateItemField from '../../../Services/updateEstimateItemField';
import type { UpdateEstimateItemFieldParams } from '../../../types';

export default (params: UpdateEstimateItemFieldParams) => async (dispatch: Function) => dispatch(updateEstimateItemField(params));